(function () {
  'use strict';

  angular
    .module('flightBlockTimeReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('flightBlockTimeReport', {
        url: '/flight-block-time-report',
        views:{
        	'flightBlockTimeReportView' : {
        		templateUrl: 'flight-block-time-report/views/flight-block-time-report.tpl.html',
                controller: 'FlightBlockTimeReportCtrl',
                controllerAs: 'flightBlockTimeReport'
        	}
        }
      });
  }
}());
